<template>
  <header id="page-topbar">
    <div class="container">
      <div class="row">
        <div class="col-6">
          <!-- LOGO -->
          <div class="navbar-brand-box">
            <router-link to="/sign-up" class="logo">
              <span class="logo-sm">
                <h4 class="col-12 text">MY BIKE, MY BUSINESS</h4>
                <!-- <img
                  class="img-sm"
                  src="@/assets/images/gomo_logo.png"
                  alt
                  height="32"
                /> -->
              </span>
            </router-link>
          </div>
        </div>

        <div class="col-6">
          <div class="navbar-brand-box">
            <router-link to="/sign-up" class="logo">
              <span class="logo-sm">
                <img
                  class="img-sm float-right"
                  src="@/assets/images/premier_logo.png"
                  alt
                  height="70"
                />
              </span>
            </router-link>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 text" style="padding:8px;text-align:center;">Empowering the last mile delivery rider!</div>
      </div>
    </div>
  </header>
</template>

<style lang="scss"></style>

<script>
export default {
  components: {},
  computed: {},
  mounted() {},
  unmounted() {},
  methods: {},
};
</script>
